import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { Selectors, State } from '@grandvisionhq/auth';
import { toast } from '@grandvisionhq/common';
import { useIntl, useSelector } from '@grandvisionhq/state';
import { useCreateEyeExam } from '../../hooks/use-create-eye-exam.js';
import { LaunchEyeExam } from './LaunchEyeExam.js';
import { LoginForEyeExam } from './LoginForEyeExam.js';
import { isRecoverableError } from '../../types/error.js';

const LaunchEyeExamContainer = ({ onLogin , onStartEyeExam , onConsent  })=>{
    const { getLabel  } = useIntl();
    const auth = useSelector(Selectors.getAuth);
    const formattedRoutes = useSelector(Selectors.getFormattedRoutes);
    const isAuthLoading = State.getLoggedInState(auth) === 'loading';
    const loginRoute = (formattedRoutes === null || formattedRoutes === void 0 ? void 0 : formattedRoutes.login) || '';
    const { createEyeExam , eyeExamUrl , hasConsentOnLoad , loading , error  } = useCreateEyeExam();
    const [consentIsChecked, setConsentIsChecked] = React__default.useState(!!hasConsentOnLoad);
    const [errorMissingConsent, setErrorMissingConsent] = React__default.useState();
    const isLoading = isAuthLoading || loading;
    const hideConsent = isLoading || hasConsentOnLoad === true;
    const labels = React__default.useMemo(()=>({
            caption: getLabel('elements.eyeExamCta.redirectToExam'),
            loggedOutCaption: getLabel('elements.eyeExamCta.loginAction'),
            consentText: getLabel('elements.eyeExam.consent'),
            missingConsentError: getLabel('elements.eyeExam.consent.missing.error')
        })
    , [
        getLabel
    ]);
    const handleSubmit = React__default.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(event) {
            var ref, ref1, ref2;
            event.preventDefault();
            setErrorMissingConsent(false);
            if (!hasConsentOnLoad && !consentIsChecked) {
                setErrorMissingConsent(true);
                return;
            }
            onStartEyeExam === null || onStartEyeExam === void 0 ? void 0 : onStartEyeExam();
            if (eyeExamUrl) {
                return window.location.assign(eyeExamUrl);
            }
            const result = yield createEyeExam(labels.consentText);
            const url = result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : (ref1 = ref.createEyeExam) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.eyeExam) === null || ref2 === void 0 ? void 0 : ref2.examUrl;
            if (url) {
                window.location.assign(url);
            } else {
                toast.failed('common.errors.recoverable.generic');
            }
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), [
        hasConsentOnLoad,
        consentIsChecked,
        createEyeExam,
        labels,
        eyeExamUrl,
        onStartEyeExam
    ]);
    const handleChangeConsent = React__default.useCallback(()=>{
        onConsent === null || onConsent === void 0 ? void 0 : onConsent(!consentIsChecked);
        setConsentIsChecked(!consentIsChecked);
    }, [
        setConsentIsChecked,
        consentIsChecked,
        onConsent
    ]);
    React__default.useEffect(()=>{
        // checkConsent is nonrecoverable but we don't want to show the error
        // instead we will show the consent checkbox if checkConsent fails
        if (error && isRecoverableError(error)) {
            toast.failed('common.errors.recoverable.generic');
        }
    }, [
        error
    ]);
    if (State.isLoggedIn(auth)) {
        return /*#__PURE__*/ React__default.createElement(LaunchEyeExam, {
            onChangeConsent: handleChangeConsent,
            onSubmit: handleSubmit,
            isLoading: isLoading,
            consentValue: consentIsChecked,
            hideConsent: hideConsent,
            errorMissingConsent: errorMissingConsent,
            labels: labels
        });
    }
    return /*#__PURE__*/ React__default.createElement(LoginForEyeExam, {
        isLoading: isAuthLoading,
        caption: labels.loggedOutCaption,
        onClick: onLogin,
        href: typeof window !== 'undefined' ? `${loginRoute}?returnPath=${window.location.pathname}` : loginRoute
    });
};

export { LaunchEyeExamContainer };
//# sourceMappingURL=LaunchEyeExamContainer.js.map
